<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ct" id="thebutterfly"><a href="#/5TOC#theb">THE BUTTERFLY EFFECT</a></h1>
<p class="noind"><i>Physicists like <a id="page10">to think that all you have to do is say, these are the conditions, now what happens next?</a></i></p><a id="page10">
<p class="txr">—<span class="small">RICHARD P. FEYNMAN</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 8-thebutterfly.vue?740f6f7d